import { useEffect, useRef } from 'react';
import './placeholder.css'
import uuid from 'react-uuid';
import Overlay from '../overlay/Overlay';
import ContentGrid from '../ContentGrid';
import Spacer from '../Spacer';
import PlaceHolderService, { IPlaceHolderService } from './PlaceHolderService';

interface ListPlaceholderProps {
    count?: number,
    title?: string,
    titleIcon?: string,
    size?: string
}
export const ListPlaceholder = ({
    count = 3,
    title,
    titleIcon,
    size = "large"
}: ListPlaceholderProps) => {

    const ref = useRef<HTMLDivElement>(null);
    const service: IPlaceHolderService = new PlaceHolderService();

    useEffect(() => {
        const guid = uuid();
        const height = service.getHeight(size);

        for (const child of ref.current?.children as any) {
            child.remove();
        }

        for (let i = 0; i < count; i++) {
            const shimmer = document.createElement("div");
            shimmer.id = `${guid}-${i}`;
            shimmer.className = "pulse";
            shimmer.style.height = `${height}px`;
            ref.current?.insertAdjacentElement('beforeend', shimmer);
        }

    }, []);

    return (
        <>
            <ContentGrid
                title={title}
                titleIcon={titleIcon}
                showOfflineWarning={false}>
                <Spacer height={20} />
                <ListPlaceholderContent ref={ref} />
            </ContentGrid>
            <Overlay isBusy={true} />
        </>
    )
}

interface ListPlaceholderContentProps {
    ref?: any
}
const ListPlaceholderContent = ({ ref }: ListPlaceholderContentProps) => {
    return (
        <div
            ref={ref}
            className="k-gap-2 pulse-placeholder"
            role="placeholder"
        />
    )
}

